// extracted by mini-css-extract-plugin
export default {"copy":"_1rRRaz_T","button":"_2hX1dqpl"};